/* MAIN */
const DEFAULT_ENGINE = 'dot';
const DEFAULT_FORMAT = 'svg';
/* EXPORT */
export { DEFAULT_ENGINE, DEFAULT_FORMAT };
